import { createContext } from 'react';

export const newPostContext = createContext({});
export const NewPostProvider = newPostContext.Provider;
export const NewPostConsumer = newPostContext.Consumer;
